import shared from './shared';
import main from './main';
import { faker } from '@faker-js/faker';

export default function (server) {
  main(server);

  const {
    locations: [SFLocation],
  } = shared(server);

  const devices = server.createList('device', 2, {
    location: SFLocation,
    lastHeartbeatAt: new Date(),
    osVersion: '11.2.6',
    ipAddress: '192.168.7.61',
    maximumOsVersion: '11.2.6',
  });

  server.create('entry', {
    location: SFLocation,
    userData: [
      { field: 'Purpose of visit', value: 'signed out boy' },
      { field: 'Host', value: faker.person.fullName() },
      { field: 'Your Phone Number', value: '+573006567644' },
    ],
    email: faker.internet.email(),
    signedInVia: 'iPad',
    signedOutVia: 'iPad',
    signedOutAt: () => new Date(),
    device: devices[0],
    signOutDevice: devices[1],
  });
}
